module.exports = __webpack_public_path__ + "img/75759.54c490f0.svg";